import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslations } from "next-intl";
import React from "react";
import { LayoutLegacy } from "@silvertours/front-legacy-entities";
import { UiLegacy } from "@silvertours/front-legacy-shared";
var ValuePropositions = function() {
    var t = useTranslations("features.benefitsLegacy.valuePropositions");
    var title = t("title");
    var propositions = [
        [
            t("propositions.1.1"),
            t("propositions.1.2"),
            t("propositions.1.3")
        ],
        [
            t("propositions.2.1"),
            t("propositions.2.2"),
            t("propositions.2.3")
        ],
        [
            t("propositions.3.1"),
            t("propositions.3.2"),
            t("propositions.3.3")
        ], 
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(UiLegacy.SectionTitle, {
                children: title
            }),
            /*#__PURE__*/ _jsx(LayoutLegacy.Grid, {
                columns: propositions,
                children: function(items) {
                    return /*#__PURE__*/ _jsx(UiLegacy.BulletList, {
                        items: items,
                        type: "checkmark"
                    });
                }
            })
        ]
    });
};
export { ValuePropositions };
